import React, { useContext, useState } from "react"
import { AuthContext } from "../../context/AuthContext"
import {
    collection,
    addDoc,
    doc,
    updateDoc,
    serverTimestamp,
    arrayUnion,
} from "firebase/firestore"
import { db } from "../../firebase"
import { handleUpdateReceiverChats, handleNewMessageNotif, handleUpdateChatroomOnListing, handleNewChatNotif } from "../../helpers/HelperFunctions"
import spinner from "../../assets/spinner2.svg"

const InitiateMessage = ({listing, disabled}) => {
    console.log(listing)

    const [message, setMessage] = useState(disabled ? "You've already sent a message!" : "Hi, is this still available?")
    const [chatDisabled, setChatDisabled] = useState(disabled)
    const [isLoading, setIsLoading] = useState(false)

    const { currentUser } = useContext(AuthContext)

    const sendMessage = async (chatroomId) => {
        console.log("sending message")
        const time = serverTimestamp()
        await addDoc(
            collection(db, `chatrooms/${chatroomId}/messages`),
            {
                chatroomId: chatroomId,
                listingId: listing.id,
                listingTitle: listing.title,
                listingDescription: listing.description,
                sender: {
                    // email: currentUser.email,
                    uid: currentUser.uid,
                    firstName: currentUser.firstName
                },
                receiver: {
                    // email: listing.user.email,
                    uid: listing.user.userId,
                    firstName: listing.user.firstName
                },
                message: message,
                createdAt: time
            }
        )
        await updateDoc(doc(db, "chatrooms", chatroomId),{
            lastActive: time
        })
    }

    const createNewChat = async () => {
        console.log("creating new chat")
        await addDoc(
            collection(db, "chatrooms"),
            {
                listingId: listing.id,
                thumbnail: listing.image_urls[0],
                listingTitle: listing.title,
                to: {
                    // email: listing.user.email,
                    uid: listing.user.userId,
                    firstName: listing.user.firstName
                },
                from: {
                    // email: currentUser.email,
                    uid: currentUser.uid,
                    firstName: currentUser.firstName
                },
                active: true,
                lastSender: currentUser.uid,
                unread: true
            }
        ).then(async e => {
            console.log("updating user with new chat")
            await updateDoc(doc(db, "chatrooms", e.id), {
                chatId: e.id
            })

            await sendMessage(e.id)
            const chatNotifObj = {
                recipientId: listing.user.userId,
                senderName: currentUser.firstName,
                message: message,
                avatarUrl: currentUser.avatarUrl,
                listingTitle: listing.title,
                listingImage: listing.image_urls[0]
            }
            console.log(chatNotifObj)
            handleNewChatNotif(chatNotifObj)
            const chatListingObj = {
                chatId: e.id, 
                listingId: listing.id, 
                buyingUser: currentUser.uid,
                sellingUser: listing.user.userId,
                // listingTitle: listing.title,
                // listingDescription: listing.description,
                // listingThumbnail: listing.image_urls[0],
                // from: {
                //     email: currentUser.email,
                //     firstName: currentUser.firstName,
                //     uid: currentUser.uid,
                // },
                // to: {
                //     email: listing.user.email,
                //     firstName: listing.user.firstName,
                //     uid: listing.user.userId,
                // }
            }
            // await updateDoc(doc(db, "users", currentUser.uid),{
            await updateDoc(doc(db,`users/${currentUser.uid}/private`, "data"),{
                // "activeChats.buying": arrayUnion(chatListingObj)
                activeChats: arrayUnion(chatListingObj)
            })

            //update chats for receiver
            // await updateDoc(doc(db, "users", listing.user.userId),{
            // await updateDoc(doc(db,`users/${listing.user.userId}/private`, "data"),{
            //     "activeChats.selling": arrayUnion(chatListingObj)
            // })
            const updateObj = {
                userId: listing.user.userId,
                chatListingObj: chatListingObj
            }
            await handleUpdateReceiverChats(updateObj)

            // await updateDoc(doc(db, "users", listing.user.userId),{
            //     "activeChats.selling": arrayUnion(chatListingObj),
            //     unreadChats: arrayUnion({
            //         chatId: e.id,
            //         buyingUser: currentUser.uid,
            //         listing: {
            //             id: listing.id,
            //             image_urls: [listing.image_urls[0]],
            //             title: listing.title,
            //             buyerFirstName: currentUser.firstName,
            //             sellerFirstName: listing.user.firstName
            //         }
            //     })
            // })

            //update active chats on the listing
            // await updateDoc(doc(db,`listings/${listing.id}/private`, "data"),{
            // await updateDoc(doc(db, "listings", listing.id),{
            //     chatrooms: arrayUnion(chatListingObj.chatId)
            // })
            const chatListingIds = {
                listingId: listing.id,
                chatId: chatListingObj.chatId
            }
            await handleUpdateChatroomOnListing(chatListingIds)

            currentUser.activeChats.buying ? currentUser.activeChats.buying.push(chatListingObj) : currentUser.activeChats.buying = [chatListingObj]
        })
    }

    const onSubmitForm = async(e) => {
        e.preventDefault()
        setIsLoading(true)
        // const activeChats = currentUser.activeChats
        // let activeBuyingArray = []
        // let chatId = null
        // if (activeChats.length > 0) {
        //     activeBuyingArray = activeChats.map(chat => chat.listingId)

        //     const chat = activeChats.filter(chats => chats.listingId === listing.id)
        //     if (chat.length > 0) {
        //         chatId = chat[0].chatId
        //     } 
        // }

        const activeBuyingChats = currentUser.activeChats
        // const activeBuyingChats = currentUser.activeChats.buying
        let activeBuyingArray = []
        let chatId = null
        if (activeBuyingChats.length > 0) {
            activeBuyingArray = activeBuyingChats.map(chat => chat.listingId)

            const chat = activeBuyingChats.filter(chats => chats.listingId === listing.id)
            if (chat.length > 0) {
                chatId = chat[0].chatId
            } 
        }

        try{
            if (activeBuyingChats && activeBuyingArray.indexOf(listing.id) !== -1) {
                await sendMessage(chatId)
                const messageObj = {
                    recipientId : listing.user.userId,
                    senderName: currentUser.firstName,
                    message: message
                }
                await handleNewMessageNotif(messageObj)
            } else {
                await createNewChat()
                setChatDisabled(true)
                setMessage("Your message has been sent!")
            }
            alert("Message sent!")
        } catch(err) {
            alert(err)
        } finally {
            setIsLoading(false)
        }

        // try{
        //     console.log(isLoading)
        //     console.log(disabled)
        //     setTimeout(() => {console.log(isLoading)}, 3000)
        // } catch(err) {
        //     console.error(err)
        // } finally {
        //     setIsLoading(false)
        // }
    }

    return (
        <div className='initiate-message-container'>
            <form className='initiate-message-form' onSubmit={onSubmitForm}>
                <input 
                    value={message}
                    type="text"    
                    className="form-control"
                    onChange={
                        e=> setMessage(e.target.value)
                    }
                    disabled={chatDisabled}
                />
                <button type="submit" className="btn btn-success initiate-message-btn" value="" disabled={isLoading || chatDisabled}>
                    {isLoading ? <img src={spinner} alt="Loading..." className="button-spinner" /> : <i className="material-icons">send</i>}
                </button>
            </form>
        </div>
    )
}

export default InitiateMessage